import React from 'react';
import { ApIcon } from '@alixpartners/ui-components';

import { Section } from '../../Settings/Section';
import { Divider } from '../../Settings/Section/styles';
import {
	InitiativeSubTitle,
	PeriodRange,
	PeriodWrapper,
	MonthPickerWrapper,
	SmallInput,
	MonthPickerNameBlock,
	MonthPickerRadio,
	ActionWrapper,
	LinkButton,
	slimRadioStyles,
} from './styles';
import { TextInput } from '../../Settings/TextInput';
import RadioGroup, { Radio } from 'components/RadioGroup';
import MonthPicker from './MonthPicker';

import { MONTH_NAMES, getMonthByDate } from 'utils/date';
import { getYearByDate } from 'Details/utils';

const InitiativeTimePeriod = ({
	addCustomPeriod,
	removeCustomPeriod,
	period,
	periodsData = [],
	customPeriods = [],
	onPeriodChange,
	handleMonthPickerBlockClick,
	getMonthPickerSrcRange,
	handleMonthPickerChange,
	onCustomPeriodNameChange,
	addCustomTotalPeriod,
	removeCustomTotalPeriod,
	totalPeriod,
	periodsTotalData = [],
	customTotalPeriods = [],
	onCustomInitiativeTotalPeriodNameChange,
}) => {
	let recent12Months = null;
	let recent12MonthsPeriodText = '';

	if (!periodsData[0].year) {
		recent12Months = periodsData[0];
		const startYear = getYearByDate(recent12Months.dateFrom);
		const startMonth = MONTH_NAMES[getMonthByDate(recent12Months.dateFrom)];
		const endYear = getYearByDate(recent12Months.dateTo);
		const endMonth = MONTH_NAMES[getMonthByDate(recent12Months.dateTo)];
		recent12MonthsPeriodText = `${startYear} ${startMonth} - ${endYear} ${endMonth}`;
	}

	let recentTotal12Months = null;
	let recentTotal12MonthsPeriodText = '';

	if (!periodsTotalData[0].year) {
		recentTotal12Months = periodsTotalData[0];
		const startYear = getYearByDate(recentTotal12Months.dateFrom);
		const startMonth =
			MONTH_NAMES[getMonthByDate(recentTotal12Months.dateFrom)];
		const endYear = getYearByDate(recentTotal12Months.dateTo);
		const endMonth = MONTH_NAMES[getMonthByDate(recentTotal12Months.dateTo)];
		recentTotal12MonthsPeriodText = `${startYear} ${startMonth} - ${endYear} ${endMonth}`;
	}

	return (
		<Section title="Initiatives Time Periods" animationIndex={1}>
			<PeriodWrapper>
				<InitiativeSubTitle>Total spend time period</InitiativeSubTitle>
				<RadioGroup
					name="initiativeTotalPeriod"
					value={totalPeriod}
					onChange={onPeriodChange}
				>
					{recentTotal12Months ? (
						<Radio
							value={recentTotal12Months.id.toString()}
							style={slimRadioStyles}
						>
							{recentTotal12Months.name}
							<PeriodRange>{recentTotal12MonthsPeriodText}</PeriodRange>
						</Radio>
					) : null}
					{(!recentTotal12Months
						? periodsTotalData
						: [...periodsTotalData].splice(1, periodsTotalData.length - 1)
					).map((item, index) => (
						<Radio
							key={index}
							value={item.id.toString()}
							style={slimRadioStyles}
						>
							{item.name}
							<PeriodRange>
								{getMonthByDate(item.dateTo) - getMonthByDate(item.dateFrom) ===
								11
									? 'Full Year'
									: `${MONTH_NAMES[getMonthByDate(item.dateFrom)]} - ${
											MONTH_NAMES[getMonthByDate(item.dateTo)]
									  }`}
							</PeriodRange>
						</Radio>
					))}
					{customTotalPeriods.map(
						({ id, uid, monthPickerRange, name, error }, index) => (
							<MonthPickerRadio
								style={{
									...slimRadioStyles,
									marginTop: index === 0 ? 10 : 0,
								}}
								value={id ? id.toString() : uid}
								key={id || uid}
							>
								<MonthPickerWrapper
									isActive={id ? id.toString() === period : uid === period}
								>
									<MonthPicker
										onClick={() => {
											handleMonthPickerBlockClick(
												id || uid,
												'initiativeTotalPeriod'
											);
										}}
										srcRange={getMonthPickerSrcRange(
											'inititivesTotalPeriodsData'
										)}
										onConfirm={handleMonthPickerChange(
											id || uid,
											'customInititivesTotalPeriods',
											'initiativeTotalPeriod'
										)}
										stateRange={monthPickerRange}
										index={index}
									/>

									<MonthPickerNameBlock>
										<SmallInput error={error}>
											<TextInput
												name="customInitiativesTotalPeriodName"
												label={index === 0 ? 'Custom Total Period Name' : ''}
												value={name || ''}
												onChange={onCustomInitiativeTotalPeriodNameChange(
													id || uid
												)}
											/>
										</SmallInput>
									</MonthPickerNameBlock>

									<ActionWrapper>
										{(id ? id.toString() !== period : uid !== period) && (
											<ApIcon
												iconName="baseline_close"
												iconSize="24px"
												onClick={() => removeCustomTotalPeriod(id || uid)}
											/>
										)}
									</ActionWrapper>
								</MonthPickerWrapper>
							</MonthPickerRadio>
						)
					)}
				</RadioGroup>
				<LinkButton onClick={addCustomTotalPeriod}>
					Add{customTotalPeriods.length !== 0 ? ' new' : ''} custom period
				</LinkButton>
			</PeriodWrapper>
			<Divider />
			<PeriodWrapper>
				<InitiativeSubTitle>Initiative default time period</InitiativeSubTitle>
				<RadioGroup
					name="initiativePeriod"
					value={period}
					onChange={onPeriodChange}
				>
					{recent12Months ? (
						<Radio value={recent12Months.id.toString()} style={slimRadioStyles}>
							{recent12Months.name}
							<PeriodRange>{recent12MonthsPeriodText}</PeriodRange>
						</Radio>
					) : null}
					{(!recent12Months
						? periodsData
						: [...periodsData].splice(1, periodsData.length - 1)
					).map((item, index) => (
						<Radio
							key={index}
							value={item.id.toString()}
							style={slimRadioStyles}
						>
							{item.name}
							<PeriodRange>
								{getMonthByDate(item.dateTo) - getMonthByDate(item.dateFrom) ===
								11
									? 'Full Year'
									: `${MONTH_NAMES[getMonthByDate(item.dateFrom)]} - ${
											MONTH_NAMES[getMonthByDate(item.dateTo)]
									  }`}
							</PeriodRange>
						</Radio>
					))}
					{customPeriods.map(
						({ id, uid, monthPickerRange, name, error }, index) => (
							<MonthPickerRadio
								style={{
									...slimRadioStyles,
									marginTop: index === 0 ? 10 : 0,
								}}
								value={id ? id.toString() : uid}
								key={id || uid}
							>
								<MonthPickerWrapper
									isActive={id ? id.toString() === period : uid === period}
								>
									<MonthPicker
										onClick={() => {
											handleMonthPickerBlockClick(
												id || uid,
												'initiativePeriod'
											);
										}}
										srcRange={getMonthPickerSrcRange('inititivesPeriodsData')}
										onConfirm={handleMonthPickerChange(
											id || uid,
											'customInititivesPeriods',
											'initiativePeriod'
										)}
										stateRange={monthPickerRange}
										index={index}
									/>

									<MonthPickerNameBlock>
										<SmallInput error={error}>
											<TextInput
												name="customInitiativesPeriodName"
												label={index === 0 ? 'Custom Period Name' : ''}
												value={name || ''}
												onChange={onCustomPeriodNameChange(id || uid)}
											/>
										</SmallInput>
									</MonthPickerNameBlock>

									<ActionWrapper>
										{(id ? id.toString() !== period : uid !== period) && (
											<ApIcon
												iconName="baseline_close"
												iconSize="24px"
												onClick={() => removeCustomPeriod(id || uid)}
											/>
										)}
									</ActionWrapper>
								</MonthPickerWrapper>
							</MonthPickerRadio>
						)
					)}
				</RadioGroup>
				<LinkButton onClick={addCustomPeriod}>
					Add{customPeriods.length !== 0 ? ' new' : ''} custom period
				</LinkButton>
			</PeriodWrapper>
		</Section>
	);
};

export default InitiativeTimePeriod;
